export function kvFromObject(obj) {
    const out = [];
    for (const k of Object.keys(obj || {})) {
      const n = Number(obj[k]);
      out.push({ key: k, value: Number.isFinite(n) ? n : 0 });
    }
    return out;
  }
  
  export function kvToObject(arr) {
    const out = {};
    for (const it of arr || []) {
      if (!it) continue;
      const k = String(it.key ?? "").trim();
      if (!k) continue;
      const n = Number(it.value);
      out[k] = Number.isFinite(n) ? n : 0;
    }
    return out;
  }
  
  export function sumKV(x) {
    if (!x) return 0;
    if (Array.isArray(x)) return x.reduce((a, it) => a + (Number(it?.value) || 0), 0);
    if (typeof x === "object") return Object.values(x).reduce((a, v) => a + (Number(v) || 0), 0);
    return 0;
  }
  
  export function ensureKvArray(x) {
    return Array.isArray(x) ? x : kvFromObject(x || {});
  }
  